import { FC, useEffect, useRef } from 'react';
import { Form, FormField, FormProps } from '../../forms';
import { ContentDialog } from '../contentDialog';
import { FormikProps, FormikValues } from 'formik';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  title: string;
  width?: string;
  onClose?: () => void;
  saveButtonText?: string;
  resetButtonText?: string;
  children: FormField;
} & Omit<FormProps, 'children'>;

export const FormDialog: FC<Props> = ({
  open,
  title,
  width,
  onSubmit,
  onClose,
  saveButtonText,
  resetButtonText,
  children
}) => {
  const { t } = useTranslation();
  const formikRef = useRef<FormikProps<FormikValues>>(null);

  useEffect(() => {
    if (!open) {
      formikRef.current?.resetForm();
    }
  }, [open]);

  return (
    <ContentDialog
      open={open}
      title={title}
      width={width}
      onClose={onClose}
      primaryButton={saveButtonText ?? t('common:SAVE')}
      tertiaryButton={resetButtonText ?? t('common:CANCEL')}
      onPrimaryButtonClick={() => {
        formikRef.current?.submitForm();
      }}
      onTertiaryButtonClick={onClose}
    >
      <Form formRef={formikRef} onSubmit={onSubmit} useCustomButton>
        {children}
      </Form>
    </ContentDialog>
  );
};
